export default "https://storage.googleapis.com/prepweb-prod/dist/e2671655e0f2d949287373b4f9354ab3.png";